import * as React from 'react';
import { connect } from 'react-redux';

import { Messages } from '../../../codegen/Localize';
import { FeatureFlags } from '../../../ts/FeatureFlags';
import { L10n } from '../../../ts/L10n/L10n';
import { FlowContentType } from '../../../ts/models/ContentTypes';
import { ISpaceItemDetailInfo } from '../../../ts/models/ISpaceItemDetailInfo';
import { FlowAllowedActions } from '../../../ts/ServerApi/types/FlowAllowedActions';
import { IDatasourceActions } from '../../../ts/ServerApi/types/IDatasourceActions';
import { IWorkbookActions } from '../../../ts/ServerApi/types/IWorkbookActions';
import { SessionServerSelectors } from '../../selectors/SessionInfoSelectors';
import { AppState } from '../../state/AppState';
import { MapStateToProps } from '../../utils/ConnectUtils';
import { ConnectedEncryptionStatusDropdown } from './EncryptionStatusDropdown';
import { SpaceHeaderTestIds } from './SpaceHeader';
import { SpaceHeaderStyles } from './SpaceHeaderStyles';

export function ExtractMetadata(props: ExtractMetadataProps): JSX.Element {
  const { itemInfo, availableActions, isEncryptionEnabled } = props;
  const lastRefreshedDate = itemInfo.lastRefreshedAt;
  const showExtractInfo = itemInfo.hasExtracts && lastRefreshedDate;
  let showEncryptionStatus = isEncryptionEnabled && itemInfo.hasEncryptableExtracts;
  if (showEncryptionStatus && itemInfo.contentType === FlowContentType.name && !FeatureFlags.maestroEarEnabled) {
    showEncryptionStatus = false;
  }
  // Disable business logic is taken care by the backend. One of the following conditions must be true to disable the dropdown actions
  // 1) User does not have permissions, Or
  // 2) Site Encryption is in Enforced/Disabled mode
  const disableEncryptionActions: boolean = availableActions.decryptExtracts === false && availableActions.encryptExtracts === false;
  return (
    <React.Fragment>
      {showEncryptionStatus &&
        <ConnectedEncryptionStatusDropdown itemInfo={itemInfo} disabled={disableEncryptionActions} />}
      {showExtractInfo &&
        <React.Fragment>
          {!showEncryptionStatus &&
            <span className={SpaceHeaderStyles.TextOnlyMetadataLabelWithLeftMargin}>
              {Messages.datasourceHeaderLastRefreshed()}
            </span>}
          <span className={SpaceHeaderStyles.MetadataInfo} data-tb-test-id={SpaceHeaderTestIds.lastRefreshed} title={Messages.datasourceHeaderLastRefreshed()}>
            {L10n.localizedDateTime(lastRefreshedDate)}
          </span>
        </React.Fragment>}
    </React.Fragment>
  );
}

export interface ExtractMetadataOwnProps {
  itemInfo: ISpaceItemDetailInfo<'workbook' | 'datasource' | 'flow'>;
  availableActions: IDatasourceActions | IWorkbookActions | FlowAllowedActions;
}

export interface ExtractMetadataStateProps {
  isEncryptionEnabled: boolean;
}

export type ExtractMetadataProps = ExtractMetadataOwnProps & ExtractMetadataStateProps;

const mapStateToProps: MapStateToProps<ExtractMetadataStateProps> = (state: AppState) => {
  return {
    isEncryptionEnabled: SessionServerSelectors.extractEncryptionEnabledOmniSwitch(state)
  };
};

export const ConnectedExtractMetadata = connect(mapStateToProps)(ExtractMetadata);
